import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=04891d30"
import script from "./contact-us.vue?vue&type=script&lang=js"
export * from "./contact-us.vue?vue&type=script&lang=js"
import style0 from "./contact-us.vue?vue&type=style&index=0&id=04891d30&lang=less"
import style1 from "./contact-us.vue?vue&type=style&index=1&id=04891d30&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04891d30')) {
      api.createRecord('04891d30', component.options)
    } else {
      api.reload('04891d30', component.options)
    }
    module.hot.accept("./contact-us.vue?vue&type=template&id=04891d30", function () {
      api.rerender('04891d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customer/contact-us.vue"
export default component.exports